<template>
	<svg
		:width="size"
		:height="size"
		viewBox="0 0 18 18"
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		role="img"
		:aria-hidden="ariaHidden"
	>
		<path
			d="M8.67255 2.44776C8.70492 2.38897 8.75248 2.33994 8.81026 2.30579C8.86805 2.27165 8.93393 2.25363 9.00105 2.25363C9.06817 2.25363 9.13406 2.27165 9.19184 2.30579C9.24962 2.33994 9.29718 2.38897 9.32955 2.44776L11.5436 6.65076C11.5963 6.74809 11.67 6.83251 11.7593 6.89798C11.8486 6.96345 11.9513 7.00833 12.06 7.02941C12.1687 7.05049 12.2807 7.04724 12.388 7.0199C12.4953 6.99255 12.5952 6.9418 12.6806 6.87126L15.8883 4.12326C15.9499 4.07318 16.0258 4.04393 16.105 4.03972C16.1843 4.0355 16.2628 4.05655 16.3294 4.09982C16.3959 4.1431 16.447 4.20637 16.4753 4.28053C16.5036 4.35469 16.5076 4.43592 16.4868 4.51251L14.3613 12.197C14.3179 12.3543 14.2244 12.4931 14.0951 12.5924C13.9657 12.6918 13.8074 12.7462 13.6443 12.7475H4.35855C4.1953 12.7464 4.03688 12.692 3.90734 12.5926C3.77781 12.4933 3.68422 12.3544 3.6408 12.197L1.51605 4.51326C1.49524 4.43667 1.49927 4.35544 1.52756 4.28128C1.55585 4.20712 1.60694 4.14385 1.67348 4.10057C1.74001 4.0573 1.81857 4.03625 1.89783 4.04047C1.97709 4.04468 2.05297 4.07393 2.11455 4.12401L5.32155 6.87201C5.4069 6.94255 5.50681 6.99331 5.6141 7.02065C5.72139 7.04799 5.83341 7.05124 5.9421 7.03016C6.0508 7.00908 6.15348 6.9642 6.24277 6.89873C6.33206 6.83326 6.40575 6.74884 6.45855 6.65152L8.67255 2.44776Z"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M3.75 15.75H14.25"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
</template>

<script>
export default {
	name: 'IconCrown',
	props: {
		size: {
			type: [Number, String],
			default: 16
		},
		color: {
			type: String,
			default: 'currentColor'
		},
		filled: {
			type: Boolean,
			default: true
		},
		strokeWidth: {
			type: [Number, String],
			default: 1.5
		},
		ariaHidden: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		computedFill() {
			return this.filled ? this.color : 'none'
		},
		computedStroke() {
			return this.color
		}
	}
}
</script>
